import { render, staticRenderFns } from "./claimConfirmation.vue?vue&type=template&id=84618f68&scoped=true"
import script from "./claimConfirmation.vue?vue&type=script&lang=js"
export * from "./claimConfirmation.vue?vue&type=script&lang=js"
import style0 from "./claimConfirmation.vue?vue&type=style&index=0&id=84618f68&prod&lang=scss&scoped=true"
import style1 from "./claimConfirmation.vue?vue&type=style&index=1&id=84618f68&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84618f68",
  null
  
)

export default component.exports